import React from 'react';
import { Dashboard } from '@components/common/Dashboard';
import { PageLayout } from '@components/common/PageLayout';
import { DashboardBackButton } from '@components/utils';
import { ButtonClean, HeadContent, Skeleton } from '@fourthwall/components';
import { routing } from '@utils/routing';
import { ConnectBar } from '../../components/ConnectBar/ConnectBar';
import * as S from './AppsIntegrationUnified.styled';
export const AppsIntegrationUnifiedView = ({ connectBar, name, longDescription, helpCenterUrl, children, }) => (React.createElement(React.Fragment, null,
    React.createElement(HeadContent, { title: name }),
    React.createElement(PageLayout, { size: "tiny" },
        React.createElement(Dashboard.Section, { name: name, title: React.createElement(React.Fragment, null,
                longDescription,
                ' ',
                React.createElement(ButtonClean, { label: "Learn More", href: helpCenterUrl, target: "_blank" }),
                "."), topContent: React.createElement(DashboardBackButton, { label: "Apps", to: routing.apps.self }) },
            React.createElement(S.Container, null,
                connectBar ? (React.createElement(ConnectBar, { ...connectBar })) : (React.createElement(Skeleton, null,
                    React.createElement(Skeleton.Shape, { height: 64 }))),
                children)))));
